import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-manage-zip-dialog',
  templateUrl: './manage-zip-dialog.component.html',
  styleUrls: ['./manage-zip-dialog.component.scss']
})
export class ManageZipDialogComponent implements OnInit {

  toZipCheck: boolean = true;
  dialogMessage: string = "This is .zip file and unzip while data copy";

  constructor(
    public dialog: MatDialogRef<ManageZipDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      fileName: string;
    }
  ) { }
  
  ngOnInit(): void {
    if(this.data?.fileName){
      this.dialogMessage = `"${this.data?.fileName}" is a .zip file. Do you want to unzip while data copy?`;
    }
  }
  onCancel(){
    this.dialog.close(false);
  }
  
  onSubmit(){
    this.dialog.close(this.toZipCheck);
  }
}
